import type { TollReportRowDto } from "@/api/dtos";
import type { TollReportRow } from "@/api/report/_models/TollReport";

const KEY = "Order No.";

/** DTO → domain for one Toll row: the "Order No." dedupe key lifted to `id`, every column kept in `fields`. */
export const toTollReportRowFromDto = (dto: TollReportRowDto): TollReportRow => {
  const id = dto[KEY] ?? "";

  return {
    id,
    fields: dto,
  };
};
